import { Component, Input, EventEmitter, Output, OnChanges } from '@angular/core';

import { CART_DELIVERY_TYPES, getActualDeliveryPrice, UI_DELIVERY_OPTIONS } from '../../../cart';

@Component({
  standalone: false,
  selector: 'cart-delivery',
  template: `
    <div class="delivery-cart-line">
      <ng-container *ngIf="isGiftDelivery() then giftDelivery"></ng-container>
      <ng-container *ngIf="isDeliveryToDoor() then toDoorDelivery"></ng-container>
      <ng-container *ngIf="isMailDelivery() then mailDelivery"></ng-container>
      <ng-container *ngIf="isPickupDelivery() then pickupDelivery"></ng-container>

      <div class="my-3 font-sm" *ngIf="!isSideLayout || showDeliveryEdit">
        <button class="btn btn-text-primary font-sm fw-bold"
                (click)="onEditDelivery.emit()">
          {{ 'cart.editDelivery' | translate }}
        </button>
      </div>
    </div>

    <ng-template #giftDelivery>
      <div class="d-flex fw-bold mt-3 mb-2 align-items-center justify-content-between">
        <div>
          <span [translate]="'cart.giftDelivery'">Gift delivery</span>
          <span *ngIf="delivery.price">:</span>
        </div>

        <div *ngIf="delivery.price">
          {{ delivery.price | currencyFormat: currency }}
        </div>
      </div>

      <div class="mt-4 mb-3 font-sm">
        {{ delivery.deliveryUserName }}<br>
        {{ delivery.deliveryPhone }}<br>
        <span *ngIf="delivery.deliveryEmail">{{ delivery.deliveryEmail }}<br></span>
        <div class="mt-4" *ngIf="delivery.note">{{ delivery.note }}</div>
      </div>
    </ng-template>

    <ng-template #mailDelivery>
      <div class="d-flex fw-bold mt-3 mb-2 align-items-center justify-content-between">
        <span>{{ 'common.delivery.mailDelivery' | translate }}:</span>
        <span>{{ delivery.price | currencyFormat: currency }}</span>
      </div>

      <div class="mt-4 mb-3 font-sm">
        <div>{{ delivery.userName }}</div>
        <div>{{ delivery.address }}</div>
        <div>{{ delivery.postNumber }} {{ delivery.cityName }}</div>
      </div>
    </ng-template>

    <ng-template #toDoorDelivery>
      <div class="d-flex fw-bold mt-3 mb-2 align-items-center justify-content-between">
        <span>{{ 'common.delivery.deliveryToDoor' | translate }}:</span>
        <span>{{ price | currencyFormat: currency }}</span>
      </div>

      <div class="mb-2 font-sm" *ngIf="delivery.date && delivery.timeRange">
        {{ delivery.date | i18nDate : 'dddd D.' }}
        <span class="text-lowercase">
          {{ delivery.date | i18nDate : 'MMM' }}
        </span>
        {{ delivery.timeRange }}
      </div>

      <div class="mt-4 mb-3 font-sm">
        <div>{{ delivery.userName }}</div>
        <div>{{ delivery.phone }}</div>
        <div>{{ delivery.address }}</div>
        <div>{{ delivery.postNumber }} {{ delivery.cityName }}</div>
        <div class="mt-4" *ngIf="delivery.note">{{ delivery.note }}</div>
      </div>
    </ng-template>

    <ng-template #pickupDelivery>
      <div class="fw-bold mt-3 mb-2">
        <span [translate]="'cart.pickup'">Pickup</span>
      </div>

      <div class="mb-2 font-sm" *ngIf="delivery.date">
        {{ delivery.date | i18nDate : 'dddd D.' }}
        <span class="text-lowercase">
          {{ delivery.date | i18nDate : 'MMM' }}
        </span>
        {{ delivery.timeRange }}
      </div>

      <div class="mb-3 font-sm">
        {{ delivery.outletName }}<br>
        {{ delivery.address }}<br>
        {{ delivery.postNumber }} {{ delivery.cityName }}
      </div>
    </ng-template>
  `
})
export class CartDeliveryComponent implements OnChanges {
  @Input() delivery: any;
  @Input() deliveryType: UI_DELIVERY_OPTIONS;
  @Input() currency: string;
  @Input() isSideLayout: boolean;
  @Input() showDeliveryEdit: boolean;

  @Output() onEditDelivery = new EventEmitter<void>();

  price = 0;

  CART_DELIVERY_TYPES = CART_DELIVERY_TYPES;

  constructor() {
  }

  ngOnChanges() {
    this.price = this.delivery ? getActualDeliveryPrice(this.delivery) : 0;
  }

  public isPickupDelivery() {
    return this.deliveryType === UI_DELIVERY_OPTIONS.PICKUP;
  }

  public isDeliveryToDoor(): boolean {
    return this.deliveryType === UI_DELIVERY_OPTIONS.DELIVERY;
  }

  public isMailDelivery(): boolean {
    return this.deliveryType === UI_DELIVERY_OPTIONS.MAIL;
  }

  public isGiftDelivery() {
    return this.deliveryType === UI_DELIVERY_OPTIONS.GIFT;
  }
}
